import { render, staticRenderFns } from "./credit-report.vue?vue&type=template&id=4f0c10f0&scoped=true"
import script from "./credit-report.vue?vue&type=script&lang=ts"
export * from "./credit-report.vue?vue&type=script&lang=ts"
import style0 from "./credit-report.vue?vue&type=style&index=0&id=4f0c10f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c10f0",
  null
  
)

export default component.exports